import React, { useState, useEffect } from "react";
import { Table, Spinner } from "reactstrap";

import { deviceDataAPI, deviceCountAPI } from "../services/Device";
import TableHeader from "../components/TableHeader";

const tablesCache = {
  data: null,
  timestamp: null,
};

const Tables = () => {
  const [deviceData, setDeviceData] = useState([]);
  const [loading, setLoading] = useState(false);

 const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;


const [totalCount, setTotalCount] = useState(null);

useEffect(() => {
    deviceCountAPI().then(res => {
      console.log("Count API response →", res);
        if (res.success) setTotalCount(res.count);
    }).catch(err => console.error("Count fetch failed:", err));
}, []);



  // const LoadingSpinner = () => {
  //   let key = Date.now()
  //   return (
  //     <tbody key={key}>
  //       <tr>
  //         <th colSpan="6">
  //           <Spinner animation="border" size="md" />
  //         </th>
  //       </tr>
  //     </tbody>
  //   )
  // }

  const refreshlist = () => {
    setLoading(true);
    document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
  tablesCache.data = null;  // ← clear cache
  getdata();
};

  const getdata = async () => {
    setLoading(true);
    getAllDevice();
  };

 const getAllDevice = async () => {
    try {
      const data = await deviceDataAPI();

      if (data.success && Array.isArray(data.devices)) {
        tablesCache.data = data.devices;
        setDeviceData(data.devices);
      setCurrentPage(1);
      setLoading(false);
      document.getElementById("refreshbtn").className = "fas fa-sync fa-stop";
      } else {
        console.warn("No devices found or API failed:", data);
      setDeviceData([]);
      setLoading(false);
      }
    } catch (error) {
      console.error("Failed to load devices:", error);
    setDeviceData([]);
        setLoading(false);
    }
  };
  const timeFormatMinSec = (dateStr) => {
    if (
      typeof dateStr == "undefined" ||
      dateStr == undefined ||
      dateStr == "undefined" ||
      dateStr < 1520160669214
    ) {
      return " ";
    }
    let date = new Date(parseInt(dateStr));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime =
      (" 0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;
    let newDate = new Date(parseInt(dateStr)).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return newDate + " (" + strTime + ")";
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = deviceData.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  const totalPages = Math.ceil(deviceData.length / recordsPerPage);


  const deviceListRecords = () => {
    if (deviceData.length > 0 && !loading) {
      return currentRecords.map((item, index) => (
        <tr key={item.id || index}>
          <td style={{ textAlign: "left" }}>{item.fobId || "-"}</td>
          <td style={{ textAlign: "left" }}>
            <a href={"/#/device/" + item.id}>{item.prcId || "-"} </a>
          </td>
          <td style={{ textAlign: "left" }}>
            {timeFormatMinSec(item.updatedAt) || "-"}
          </td>
          <td style={{ textAlign: "left" }}>{item.platform || "-"}</td>
          <td style={{ textAlign: "left" }}>
            {timeFormatMinSec(item.createdAt) || "-"}
          </td>
        </tr>
      ));
    } else {
      return (
  <tr>
    <td colSpan="5" style={{ textAlign: "center", padding: "60px 0" }}>
      {loading ? (
        <>
          <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
          <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Loading...</div>
        </>
      ) : (
        "No Record Found!"
      )}
    </td>
  </tr>
);

    }
  };

  useEffect(() => {
  if (tablesCache.data) {
    setDeviceData(tablesCache.data);
    getAllDevice(); 
  } else {
    getdata(); 
  }
}, []);

 return (
 <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100%", overflow: "hidden" }}>
    {/* Header */}
  <TableHeader 
    title="Device List" 
    onRefresh={refreshlist}
    totalCount={totalCount ?? `${deviceData.length}+`}
    hasMore={false}
/>

    {/* Table — fully scrollable */}
    <div style={{overflowY: "auto", background: "#fff" }}>
      <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            <th scope="col" style={{ textAlign: "left" }}>Remote Control ID</th>
            <th scope="col" style={{ textAlign: "left" }}>Ring Id</th>
            <th scope="col" style={{ textAlign: "left" }}>Updated Date</th>
            <th scope="col" style={{ textAlign: "left" }}>Platform</th>
            <th scope="col" style={{ textAlign: "left" }}>Created Date</th>
          </tr>
        </thead>
        <tbody>
          {deviceListRecords()}
          {/* Pagination row — inline at end of entries, only when > 50 */}
         {deviceData.length > 50 && !loading && (
    <tr>
        <td colSpan="5" style={{ textAlign: "right", padding: "12px 16px" }}>
            <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(prev => prev - 1)}
                    style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === 1 ? "#f8f9fa" : "#fff",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500,
                    }}
                >←</button>
                <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
                    {indexOfFirstRecord + 1}–{Math.min(indexOfLastRecord, deviceData.length)} of {totalCount ?? `${deviceData.length}+`}
                </div>
                <button
                    disabled={currentPage === totalPages || totalPages === 0}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                    style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === totalPages ? "#f8f9fa" : "#fff",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: 500,
                    }}
                >→</button>
            </div>
        </td>
    </tr>
)}
        </tbody>
      </Table>
    </div>
  </div>
);
};

export default Tables;
